import { UserNotificationDTO } from './userNotifications.models';

const weeklyFieldInsightsNotificationSetup: UserNotificationDTO = {
  id: 'system-weekly-field-insights-setup-notification',
  status: 'SENT',
  created_by: 'system',
  updated_by: 'system',
  created_at: new Date().toDateString(),
  updated_at: new Date().toDateString(),
  sent_at: new Date().toDateString(),
  user_notification: {
    content: {
      title: 'report_title',
      details: 'report_details',
      phrase_key: 'system_notification.weekly_field_insights.setup',
      anomalies_count: 0,
      workspace_id: 'system-workspace-id',
      workspace_name: 'system-workspace-name',
      organization_id: 'system-organization-id',
      organization_name: 'system-organization-name',
      property_id: 'system-property-id',
      property_name: 'system-property-name',
    },
  },
};
const weeklyFieldInsightsNotificationSetupComplete: UserNotificationDTO = {
  id: 'system-weekly-field-insights-setup-notification-complete',
  status: 'SENT',
  created_by: 'system',
  updated_by: 'system',
  created_at: new Date().toDateString(),
  updated_at: new Date().toDateString(),
  sent_at: new Date().toDateString(),
  user_notification: {
    content: {
      title: 'report_title',
      details: 'report_details',
      phrase_key: 'system_notification.weekly_field_insights.setup_complete',
      anomalies_count: 0,
      workspace_id: 'system-workspace-id',
      workspace_name: 'system-workspace-name',
      organization_id: 'system-organization-id',
      organization_name: 'system-organization-name',
      property_id: 'system-property-id',
      property_name: 'system-property-name',
    },
  },
};
export { weeklyFieldInsightsNotificationSetup, weeklyFieldInsightsNotificationSetupComplete };
